import React from 'react';
import { Grid } from 'semantic-ui-react';
import FeesBreakdown from './components/FeesBreakdown';
import { CurrencyNumberPropType } from '../../../../../services/proptypes';
import { formatCurrency } from '../../../../../utils/currency';
import TipSelector from '../../../TipSelector';
import { FeePropType } from '../../CartSummary.propTypes';
import './CartTotalSummary.css';
var defaultProps = {
  fulfillmentTotal: '0.00',
  fulfillmentDetails: [],
  taxTotal: '0.00',
  taxDetails: [],
  feeTotal: '0.00',
  feeDetails: [],
  tip: '0.00',
  onTipChange: null,
  hideTip: false
};
function CartTotalSummary(_ref) {
  var fulfillmentTotal = _ref.fulfillmentTotal,
    fulfillmentDetails = _ref.fulfillmentDetails,
    taxTotal = _ref.taxTotal,
    taxDetails = _ref.taxDetails,
    feeTotal = _ref.feeTotal,
    feeDetails = _ref.feeDetails,
    subTotal = _ref.subTotal,
    total = _ref.total,
    tip = _ref.tip,
    onTipChange = _ref.onTipChange,
    hideTip = _ref.hideTip;
  return /*#__PURE__*/React.createElement(Grid, {
    className: "cart-total-grid"
  }, /*#__PURE__*/React.createElement(Grid.Row, {
    className: "subtotal cart-total-row"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "left"
  }, "Subtotal"), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "right",
    textAlign: "right"
  }, formatCurrency(subTotal))), /*#__PURE__*/React.createElement(FeesBreakdown, {
    label: "Taxes",
    total: taxTotal,
    details: taxDetails
  }), /*#__PURE__*/React.createElement(FeesBreakdown, {
    label: "Fulfillment",
    total: fulfillmentTotal,
    details: fulfillmentDetails
  }), /*#__PURE__*/React.createElement(FeesBreakdown, {
    label: "Other Fees",
    total: feeTotal,
    details: feeDetails
  }), (+tip > 0 || onTipChange) && !hideTip && /*#__PURE__*/React.createElement(Grid.Row, {
    className: "tip cart-total-row"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "left"
  }, "Tip"), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "right",
    textAlign: "right"
  }, formatCurrency(tip)), onTipChange && /*#__PURE__*/React.createElement(TipSelector, {
    onChange: onTipChange
  })), /*#__PURE__*/React.createElement(Grid.Row, {
    className: "total cart-total-row bold-row"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "left"
  }, "Total"), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 8,
    floated: "right",
    textAlign: "right"
  }, formatCurrency(total))));
}
CartTotalSummary.defaultProps = defaultProps;
export default CartTotalSummary;